import { render, staticRenderFns } from "./semana.vue?vue&type=template&id=71918837&"
import script from "./semana.vue?vue&type=script&lang=js&"
export * from "./semana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports